import React, { useState } from 'react';
import { useAuth } from './AuthContext';

const Login: React.FC = () => {
  const { login } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleLogin = async (): Promise<void> => {
    setIsLoading(true);
    setError(null);
    
    try {
      // Check if environment variables are configured
      if (!process.env.REACT_APP_ZITADEL_AUTHORITY || !process.env.REACT_APP_ZITADEL_CLIENT_ID) {
        throw new Error('Zitadel configuration is missing. Please check your environment variables.');
      }
      
      await login();
    } catch (err) {
      console.error('Login error:', err);
      setError(err instanceof Error ? err.message : 'An error occurred during login');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 64px)',
        padding: '2rem',
        background: '#f8f9fa',
      }}
    >
      <div
        style={{
          maxWidth: 400,
          width: '100%',
          padding: '2rem',
          background: 'white',
          borderRadius: 8,
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        }}
      >
        <p style={{ marginBottom: '2rem', textAlign: 'center', color: '#666' }}>
          Please sign in to access the <b>addresses portal</b> and manage your addresses.
        </p>
        
        {error && (
          <div style={{ 
            marginBottom: '1rem', 
            padding: '0.75rem', 
            background: '#fee', 
            color: '#c33', 
            borderRadius: 4,
            fontSize: '14px'
          }}>
            {error}
          </div>
        )}
        
        <button
          onClick={handleLogin}
          disabled={isLoading}
          style={{
            width: '100%',
            padding: '0.75rem',
            background: isLoading ? '#ccc' : '#4494f4',
            color: 'white',
            border: 'none',
            borderRadius: 4,
            fontSize: 16,
            fontWeight: 600,
            cursor: isLoading ? 'not-allowed' : 'pointer',
          }}
        >
          {isLoading ? 'Signing In...' : 'Sign In with Zitadel'}
        </button>
      </div>
    </div>
  );
};

export default Login;
